import { matchPath } from 'react-router-dom';
import { MAP_URL_ENTITY_NAME_TO_ENTITY } from 'src/pages/CustomViews/constants';
import { trimDuplicatedSlashes } from 'src/utils/routing/use-navigate-route';

export const isPathActive = (params: {
  pathTemplate?: string;
  path: string;
  locationPath: string;
}): boolean => {
  const { path, locationPath, pathTemplate } = params;
  // Compare that exact first segments match to the location path. It is possible that multiple paths can start exact, ie
  // /settings/signal and /settings/signal-business-hours.
  if (locationPath === path) {
    return true;
  }

  if (pathTemplate) {
    return (
      matchPath({ path: pathTemplate, end: true }, trimDuplicatedSlashes(locationPath)) !==
      null
    );
  }

  /**
   * For other cases, we need more sophisticated logic to check if the path is active, instead of just
   * comparing it with location directly, because the path can be dynamic and can include params
   * in between, ex.:
   * "/views/a31cf81e-dd42-47f6-9ad1-0645dcf0d429/conversations/"
   * is a path under "/views/conversations/" menu.
   */
  const pathSegments = path.split('/').filter(Boolean);
  const locationSegments = locationPath.split('/').filter(Boolean);

  let pathIndex = 0;
  let locIndex = 0;
  while (locIndex < locationSegments.length && pathIndex < pathSegments.length) {
    const locationSegment =
      MAP_URL_ENTITY_NAME_TO_ENTITY[locationSegments[locIndex]] || locationSegments[locIndex];

    if ((locationSegment as string) === pathSegments[pathIndex]) {
      pathIndex++;
    }
    locIndex++;
  }

  return pathIndex === pathSegments.length;
};
